import { Component } from '@angular/core';
import { EvoGroupTypeModalService } from './evo-group-type-modal.service';
import { GroupTypes } from '../../../models/school/group.model';

@Component({
  selector: 'app-evo-group-type-modal',
  templateUrl: './evo-group-type-modal.component.html',
  styleUrls: ['./evo-group-type-modal.component.css']
})
export class EvoGroupTypeModalComponent {

  GroupTypes = GroupTypes;

  constructor(public modalSv: EvoGroupTypeModalService) {}

}
